import {GetSaoLucasBillsParams, SaoLucasBillItem} from 'domain/usecases';
import {makeGetSaoLucasBills} from 'main/factories/usecases';

export const getSaoLucasBills = async (
	params: GetSaoLucasBillsParams,
): Promise<SaoLucasBillItem[]> => {
	const response = await makeGetSaoLucasBills().get(params);
	return response?.data ?? [];
};
